exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mql-main[data-v-62627587] {\n  margin: 15px 20px;\n  padding: 10px;\n}\n.mql-main.border[data-v-62627587] {\n    border: 1px solid #eee;\n}\n.mql-main .el-input .el-input__inner[data-v-62627587] {\n    height: 26px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62627587","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"C://Users//Administrator//Desktop//project//admin//mql_admin_pc//src//assets//style//var-fun.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/core/MqlLayout/MqlMain/index.vue
// module id = nd7w
// module chunks = 78